import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';

import Home from './screens/Home';
import Register from './screens/auth/Register';
import Login from './screens/auth/Login';
import Search from './screens/products/Search';
import VerifyEmail from './screens/auth/VerifyEmail';
import Profile from './screens/auth/Profile';


import Allproducts from './screens/products/Allproducts';
import Product from './screens/products/Product';

import Cart from './screens/orders/Cart';
import Shipping from './screens/orders/Shipping';
import PlaceOrder from './screens/orders/PlaceOrder';
import Order from './screens/orders/Order';


import Admin from './screens/admin/Admin';
import Createproduct from './screens/admin/Createproduct';
import Allorders from './screens/admin/Allorders';
import Allusers from './screens/admin/Allusers';
import EditProduct from './screens/admin/EditProduct';

import Error from './screens/Error';

import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './screens/auth/ResetPassword';
import ForgotPassword from './screens/auth/ForgotPassword';
import { ToastContainer } from 'react-toastify';

axios.defaults.withCredentials = true;


function App() {
  const { users, cart } = useSelector((state) => { return state })
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/verify-email" element={<VerifyEmail />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/reset-password" element={<ResetPassword />} />

          <Route exact path="/myprofile" element={<ProtectedRoute> <Profile /></ProtectedRoute>} />

          <Route exact path="/search/:id" element={<Search />} />
          <Route exact path="/product/:id" element={<Product />} />

          <Route exact path="/cart" element={<Cart />} />
          <Route exact path="/shipping" element={<ProtectedRoute><Shipping /></ProtectedRoute>} />
          <Route exact path="/placeorder" element={<ProtectedRoute><PlaceOrder /> </ProtectedRoute>} />
          <Route exact path="/order/:id" element={<ProtectedRoute><Order /></ProtectedRoute>} />

          {users?.userdata?.isAdmin == true && <Route exact path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />}
          {users?.userdata?.isAdmin == true && <Route exact path="/admin/allusers" element={<ProtectedRoute><Allusers /></ProtectedRoute>} />}
          {users?.userdata?.isAdmin == true && <Route exact path="/admin/allproducts" element={<ProtectedRoute><Allproducts /></ProtectedRoute>} />}
          {users?.userdata?.isAdmin == true && <Route exact path="/admin/allorders" element={<ProtectedRoute><Allorders /></ProtectedRoute>} />}
          {users?.userdata?.isAdmin == true && <Route exact path="/admin/editproduct/:id" element={<ProtectedRoute><EditProduct /></ProtectedRoute>} />}
          {users?.userdata?.isAdmin == true && <Route exact path="/admin/createproduct" element={<ProtectedRoute><Createproduct /></ProtectedRoute>} />}
          <Route exact path="*" element={<Error />} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </>
  );
}

export default App;
